import React from 'react';
import Topbar from './Topbar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background relative overflow-x-hidden">
      {/* Background orbs */}
      <div className="orb-primary w-96 h-96 top-0 left-1/4 opacity-60" />
      <div className="orb-accent w-64 h-64 top-32 right-1/4 opacity-40" />
      <div className="orb-primary w-80 h-80 bottom-0 right-1/3 opacity-30" />

      <Topbar />
      <main className="pt-16 min-h-screen">
        {children}
      </main>
    </div>
  );
}